import FriendGridItem from "./FriendGridItem";

const FriendsCard = ({ friendsData, isFriendsLoading }) => {
    return (
        <div className="item friendsCard">
            <div className="header">
                <span className="title">
                    Your Friends
                </span>
                
                <span className="countBadge">
                    {isFriendsLoading ? "0" : friendsData?.length} Friends
                </span>
            </div>

            <div className="friendsGrid">
                {isFriendsLoading ? (
                    "Loading..."
                ) : (
                    friendsData?.slice(0, 6).map((friend) => (
                        <FriendGridItem key={friend.id} friend={friend} />
                    ))
                )}
            </div>

            {!isFriendsLoading && friendsData?.length > 6 && (
                <button className="seeMoreBtn">
                    See all friends
                </button>
            )}
        </div>
    );
};

export default FriendsCard;